/**
 * Converts an S3 pathKey to an HTTP URL
 * @reason Needed to convert S3 path format to accessible HTTP URL for HEAD requests and downloads
 * @param pathKey - S3 path in format: s3://bucket-name/path/to/file
 * @returns HTTP URL in format: https://bucket-name.s3-accelerate.amazonaws.com/path/to/file
 */
export const convertS3PathToHttpUrl = (pathKey: string): string => {
  if (!pathKey.startsWith('s3://')) {
    throw new Error('pathKey must start with s3://');
  }

  const pathWithoutProtocol = pathKey.slice(5); // Remove 's3://'
  const [bucket, ...pathParts] = pathWithoutProtocol.split('/');
  const path = pathParts.join('/');

  return `https://${bucket}.s3-accelerate.amazonaws.com/${path}`;
};
